/* =============================================================
   PlatformStrip.js — the social platforms PhoneStream's SMM engine
   grows. Brand icons from react-icons; Kick is a hand-rolled SVG
   (react-icons doesn't ship a Kick glyph). Each chip glows in its
   brand color and lifts on hover. Purely presentational.
   ============================================================= */
import React from 'react';
import {
  FaInstagram,
  FaYoutube,
  FaTiktok,
  FaSpotify,
  FaFacebookF,
  FaTwitter,
  FaTelegramPlane,
} from 'react-icons/fa';

// Kick logo — blocky "K" (Simple-Icons style), drawn inline so we don't depend
// on a react-icons export that may not exist in this version.
const KickIcon = (props) => (
  <svg viewBox="0 0 32 32" fill="currentColor" aria-hidden="true" {...props}>
    <path d="M4 3h8v6.5h2.2V6.3h2.2V3h9.6v9.6h-2.2v3.2h2.2V19h2.2v10h-9.6v-3.3h-2.2v-3.2H12V29H4z" />
  </svg>
);

const PLATFORMS = [
  { name: 'Instagram', Icon: FaInstagram, color: '#E1306C' },
  { name: 'YouTube', Icon: FaYoutube, color: '#FF0000' },
  { name: 'TikTok', Icon: FaTiktok, color: '#00e0ff' },
  { name: 'Spotify', Icon: FaSpotify, color: '#1DB954' },
  { name: 'Facebook', Icon: FaFacebookF, color: '#1877F2' },
  { name: 'Kick', Icon: KickIcon, color: '#53FC18' },
  { name: 'X', Icon: FaTwitter, color: '#7ad7ff' },
  { name: 'Telegram', Icon: FaTelegramPlane, color: '#229ED9' },
];

const PlatformStrip = () => (
  <div className="neo-platform-row">
    {PLATFORMS.map(({ name, Icon, color }) => (
      <div className="neo-plat" key={name} style={{ '--brand': color }} title={name}>
        <span className="neo-plat-ic"><Icon /></span>
        <span className="neo-plat-name">{name}</span>
      </div>
    ))}
  </div>
);

export default PlatformStrip;
